module.exports = __webpack_public_path__ + "img/empty_decomposition.a2daa2af.png";